<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { loadingWatcher } from '@/mixins/loading-buefy'

  const default_layout = "default";

  export default {
    mixins: [ loadingWatcher ],
    computed: {
      ...mapState({
        loading: state => state.loading,
        errors: state => state.errors
      }),
      layout() {
        return (this.$route.meta.layout || default_layout) + "-layout";
      }
    }
  };
</script>


<style lang="scss">
</style>
